module.exports = __webpack_public_path__ + "img/arrow-down-circle.a10e109f.svg";